import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "youtube"
const YoutubeIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21.79 8.018S21.593 6.648 20.992 6.042C20.235 5.25 19.384 5.25 18.986 5.202 16.198 5 12.004 5 12.004 5H11.996S7.803 5 5 5.202C4.609 5.25 3.757 5.25 2.992 6.042 2.398 6.65 2.203 8.018 2.203 8.018S2 9.636 2 11.246V12.754C2 14.364 2.203 15.974 2.203 15.974S2.398 17.344 3 17.95C3.757 18.743 4.757 18.72 5.202 18.798 6.803 18.953 11.996 19 11.996 19S16.198 18.992 18.994 18.79C19.384 18.743 20.236 18.743 21.001 17.95 21.602 17.343 21.798 15.974 21.798 15.974S22 14.364 22 12.754V11.246C21.992 9.636 21.79 8.018 21.79 8.018M9.933 14.582V8.99L15.34 11.798z" />
        </svg>
      }
    </span>
  )
}
export default YoutubeIcon
